import DASHED from '@/assets/image/border/dashed.svg';
import DOTTED from '@/assets/image/border/dotted.svg';
import DOUBLE from '@/assets/image/border/double.svg';
import ROUGH_MEDIUM from '@/assets/image/border/rough-medium.png';
import ROUGH_THICK from '@/assets/image/border/rough-thick.png';
import ROUGH_THIN from '@/assets/image/border/rough-thin.png';
import SOLID from '@/assets/image/border/solid.svg';
import PLACE_HOLDER from '@/assets/image/content-placeholder.jpg';
import PLAY_ICON from '@/assets/icons/play.svg';
import LOCATION_PURPLE from '@/assets/icons/location-purple.svg';
import LOCATION_WHITE from '@/assets/icons/location-white.svg';
import LOCATION_DISABLED_PURPLE from '@/assets/icons/location-disabled-purple.svg';
import LOCATION_DISABLED_WHITE from '@/assets/icons/location-disabled-white.svg';
import LOCATION_DISABLED_GRAY from '@/assets/icons/location-disabled-gray.svg';
import CONTROL_ICON from '@/assets/image/control.png';
import ADD_TEXT_ICON from '@/assets/image/add-text.jpg';
import ADD_IMAGE_ICON from '@/assets/image/add-image.jpg';
import EMPTY_PREVIEW_FRAME from '@/assets/image/no-preview-frame.jpg';
import BLANK_THUMB from '@/assets/image/blank-thumb.jpg';
import BACKGROUND_AI_01 from '@/assets/image/backgrounds/generate-01.png';
import BACKGROUND_AI_02 from '@/assets/image/backgrounds/generate-02.png';
import BACKGROUND_AI_03 from '@/assets/image/backgrounds/generate-03.png';
import CLIPART_AI_01 from '@/assets/image/clip-art/generate-01.png';
import CLIPART_AI_02 from '@/assets/image/clip-art/generate-02.png';
import CLIPART_AI_03 from '@/assets/image/clip-art/generate-03.png';

export const IMAGE_LOCAL = {
  DASHED,
  DOTTED,
  DOUBLE,
  ROUGH_MEDIUM,
  ROUGH_THICK,
  ROUGH_THIN,
  SOLID,
  PLACE_HOLDER,
  PLAY_ICON,
  CONTROL_ICON,
  EMPTY_PREVIEW_FRAME,
  ADD_TEXT_ICON,
  ADD_IMAGE_ICON,
  LOCATION_WHITE,
  LOCATION_PURPLE,
  LOCATION_DISABLED_WHITE,
  LOCATION_DISABLED_PURPLE,
  LOCATION_DISABLED_GRAY,
  BLANK_THUMB,
  LOWSIZE_PERCENT: 25,
  BACKGROUND_AI_01,
  BACKGROUND_AI_02,
  BACKGROUND_AI_03,
  CLIPART_AI_01,
  CLIPART_AI_02,
  CLIPART_AI_03
};

export const RATE_DIFFERENT_NUMBER = 0.08;
